/**
 * Formatting utilities for the Prompts feature.
 */

export function formatNumber(n: number): string {
  if (n >= 1_000_000) return `${(n / 1_000_000).toFixed(1)}M`
  if (n >= 1_000) return `${(n / 1_000).toFixed(1)}K`
  return n.toString()
}

export function formatRelativeDate(dateStr: string): string {
  const date = new Date(dateStr)
  const now = new Date()
  const diffMs = now.getTime() - date.getTime()
  const diffSec = Math.floor(diffMs / 1000)
  const diffMin = Math.floor(diffSec / 60)
  const diffHr = Math.floor(diffMin / 60)
  const diffDay = Math.floor(diffHr / 24)

  if (diffSec < 60) return 'just now'
  if (diffMin < 60) return `${diffMin}m ago`
  if (diffHr < 24) return `${diffHr}h ago`
  if (diffDay < 7) return `${diffDay}d ago`
  if (diffDay < 30) return `${Math.floor(diffDay / 7)}w ago`

  return date.toLocaleDateString('en-US', {
    month: 'short',
    day: 'numeric',
    year: date.getFullYear() !== now.getFullYear() ? 'numeric' : undefined,
  })
}

export function formatDate(dateStr: string): string {
  return new Date(dateStr).toLocaleDateString('en-US', {
    month: 'short',
    day: 'numeric',
    year: 'numeric',
  })
}

export function truncateText(text: string, maxLength: number): string {
  if (text.length <= maxLength) return text
  return text.slice(0, maxLength).trimEnd() + '...'
}

export function slugify(text: string): string {
  return text
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, '-')
    .replace(/^-+|-+$/g, '')
    .slice(0, 200)
}

export function shortHash(hash: string): string {
  return hash.slice(0, 7)
}

export function categoryColor(category: string): string {
  const colors: Record<string, string> = {
    coding: '#6366F1',
    creative: '#8B5CF6',
    copywriting: '#EC4899',
    content: '#14B8A6',
    email: '#F59E0B',
    social: '#3B82F6',
    seo: '#10B981',
    research: '#6366F1',
    analysis: '#8B5CF6',
    translation: '#06B6D4',
    education: '#F97316',
    marketing: '#EF4444',
    sales: '#84CC16',
    'customer-support': '#A855F7',
    writing: '#EC4899',
    'data-analysis': '#8B5CF6',
    devops: '#0EA5E9',
    testing: '#10B981',
    security: '#EF4444',
    design: '#F97316',
    finance: '#84CC16',
    legal: '#6B7280',
    other: '#6B7280',
  }
  return colors[category] ?? colors.other
}
